const TEAM_ROUTE_BY_HUB = {
  team: {
    all: "Plan Team All",
    a: "Plan Team A",
    b: "Plan Team B",
    c: "Plan Team C",
  },
  plan: {
    all: "Plan Team All",
    a: "Plan Team A",
    b: "Plan Team B",
    c: "Plan Team C",
  },
};

export function normalizePlanNavTeam(raw) {
  const team = String(raw || "").trim().toLowerCase();
  if (team === "a" || team === "team a" || team === "teama") return "a";
  if (team === "b" || team === "team b" || team === "teamb") return "b";
  if (team === "c" || team === "team c" || team === "teamc" || team === "unassign") return "c";
  return "all";
}

export function planListRouteFromDetailQuery(query) {
  const from = String(query?.from || "team");
  if (from === "qa") return null;
  if (from === "old") return { path: "/test-plan" };
  const hub = from === "plan" ? "plan" : "team";
  const team = normalizePlanNavTeam(query?.team);
  const name = TEAM_ROUTE_BY_HUB[hub][team];
  const board = String(query?.board || "").toLowerCase();
  const nextQuery = {};
  if (["calendar", "ready", "current", "backlog", "history"].includes(board)) {
    nextQuery.board = board;
  }
  return Object.keys(nextQuery).length ? { name, query: nextQuery } : { name };
}

export function isPlanListChildActive(childTo, route) {
  const target = childTo || {};
  if (target.name && route?.name === target.name) return true;
  if (target.path && route?.path === target.path) return true;
  if (route?.name !== "Test Plan Detail") return false;
  const listRoute = planListRouteFromDetailQuery(route.query);
  return !!(listRoute?.name && target.name === listRoute.name);
}
